/**
 * Extracted from sections/ns-sticky-nav-bar.liquid (inline <script> at line 92).
 * Config bridge: window.__nsStickyNavBarSections, keyed by section id — the inline block
 * only needed Liquid for the section id, so the id is now handed over as
 * data and the logic runs from a cacheable, deferred asset instead of
 * being parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances still each initialise.
 */

(function () {
  var cfg = window.__nsStickyNavBarSections = window.__nsStickyNavBarSections || {};
  function boot(sectionId, settings) {
  function sticktNavLayout () {
    let section = document.querySelector(`#shopify-section-${sectionId}`)
    document.documentElement.style.setProperty('--sticky-product-nav-height', `${section.clientHeight}px`);
    document.documentElement.style.setProperty('--has-sticky-product-nav', 1);
  
    let breakpoint = window.matchMedia('(min-width:700px)');
    let contentContainerEl = section.querySelector('.ns-sticky-nav__content')
    let swiperWrapperEl = section.querySelector('[data-swiper-wrapper]')
    let swiperEl = section.querySelector('[data-swiper-container]')
    let {
      layoutMobile,
      layoutDesktop,
      itemsPerRowDesktop,
      itemsPerRowMobile,
    } = contentContainerEl.dataset
  
    let stickyNavSwiper
    function initializeSwiper () {
      if (stickyNavSwiper) return;
      stickyNavSwiper = new Swiper(swiperEl , {
        slidesPerView: 'auto',
        freeMode: true,
        // loopAdditionalSlides: 10,
      
        spaceBetween: 10,
        loop: true,
  
        speed: 500,

        breakpoints: {
          320: {
            freeMode: false,
            slidesPerGroup: 2,
          },
          480: {
            slidesPerGroup: 2,
          },
          500: {
            slidesPerGroup: 2,
          }
        },
    
        autoHeight: true,
      
        navigation: {
          nextEl: section.querySelector('.swiper-button-next'),
          prevEl: section.querySelector('.swiper-button-prev'),
        },
      
      })
    }  
  
  
    function destroySwiper() {
        if (typeof stickyNavSwiper !== 'undefined') {
            stickyNavSwiper.destroy(true, true)
        }
    }
    function breakpointChecker(breakpoint) {
        if (breakpoint.matches === true) {
          swiperWrapperEl.style.display = 'flex'
          swiperWrapperEl.classList.remove('swiper-wrapper')
          destroySwiper();
          return
        } else if (breakpoint.matches === false) {
          if (layoutMobile == 'slider') {
            swiperWrapperEl.style.display = 'flex'
            swiperWrapperEl.classList.add('swiper-wrapper')
            initializeSwiper()
            return
          } else {
            swiperWrapperEl.style.display = 'flex'
            swiperWrapperEl.classList.remove('swiper-wrapper')
            destroySwiper();
            swiperWrapperEl.style.overflow = 'scroll'
            return          
          }
        }
    };
  
  
    breakpointChecker(breakpoint);
    breakpoint.addEventListener("change", () => {
        breakpointChecker(breakpoint)
    })
  
  }

  
  nsSwiperReady(sticktNavLayout)
  
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      nsSwiperReady(sticktNavLayout)
    });
  }
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
